import { Title2, Body1, Button } from "@fluentui/react-components";

export default function NotFound() {
  return (
    <div style={{ textAlign: "center", marginTop: "4rem" }}>
      <Title2>Page not found</Title2>
      <Body1>We couldn't find what you were looking for.</Body1>
      <div style={{ marginTop: "1.5rem" }}>
        <Button as="a" href="/" appearance="primary">Back to dashboards</Button>
      </div>
    </div>
  );
}
